var utils_vars = {

	// DOM ready
	domReady: (callback) => {
		document.readyState === "interactive" || document.readyState === "complete"
			? callback()
			: document.addEventListener("DOMContentLoaded", callback);
	},

	// loop helper
	forEach(array, callback, scope) {
		for (var i = 0; i < array.length; i++) {
			callback.call(scope, i, array[i]);
		}
	},

	isImageLoaded(img, callback) {
		img.onload = () => callback(); 
	},

	// funzione di caricamento ajax
	ajaxLoad(url, method, contentType, type, params, callback) {
		var oReq = new XMLHttpRequest();
		oReq.onload = function (e) {
			var response = e.target.response;
			if (callback) {
				callback(response);
			}
		};
		oReq.open(method, url, true);
		if (type) {
			oReq.responseType = type;
		}
		if (contentType) {
			oReq.setRequestHeader('Content-type', contentType);
		}
		if (params) {
			oReq.send(params);
		} else {
			oReq.send();
		}
	},

};

export default utils_vars;
